import axios from "axios";

const car = {
    state: {
        types: [],
        fuels: [],
        vehicles: [],
        equipments: [],
        statuses: [],
        services: []
    },

    actions: {

        async A_CAR_TYPES({ commit, state }) {
            if (!localStorage.getItem('carTypes')) {
                await axios.get('/api/car/types')
                    .then(res => {
                        localStorage.setItem('carTypes', JSON.stringify(res.data))
                        commit('M_ADD_TYPES_CAR', res.data);
                    })
                    .catch(err => {
                        console.log(err)
                    });
            } else {
                commit('M_ADD_TYPES_CAR', JSON.parse(localStorage.getItem('carTypes')));
            }
        }
    },

    mutations: {
        M_ADD_TYPES_CAR(state, payload) {
            state.types = payload.types;
            state.fuels = payload.fuels;
            state.vehicles = payload.vehicles;
            state.equipments = payload.equipments;
            state.statuses = payload.statuses;
            state.services = payload.services;
        }
    },
    getters: {
        GET_TYPE_FUELS: state => { return state.fuels },
        GET_TYPE_VEHICLES: state => { return state.vehicles },
        GET_CAR_TYPES: state => { return state.types },
        GET_CAR_STATUSES: state => { return state.statuses },
        GET_CAR_EQUIPMENTS: state => { return state.equipments },
        GET_SERVICES: state => { return state.services }
    }
}

export default car
